"use client";

import { Menu, Button, Text } from "@mantine/core";
import { IconChevronDown, IconLanguage } from "@tabler/icons-react";
import { useLocale } from "next-intl";
import { usePathname, useRouter } from "@/i18n/navigation";
import { locales, type Locale } from "@/i18n/config";

const localeNames: Record<Locale, string> = {
  en: "English",
  es: "Español",
  pl: "Polski",
  fr: "Français",
  pt: "Português",
  it: "Italiano",
  id: "Bahasa Indonesia",
  hi: "हिन्दी",
  ko: "한국어",
  ru: "Русский",
  de: "Deutsch",
};

const localeFlags: Record<Locale, string> = {
  en: "🇺🇸",
  es: "🇪🇸",
  pl: "🇵🇱",
  fr: "🇫🇷",
  pt: "🇵🇹",
  it: "🇮🇹",
  id: "🇮🇩",
  hi: "🇮🇳",
  ko: "🇰🇷",
  ru: "🇷🇺",
  de: "🇩🇪",
};

export function LanguageSwitcher() {
  const locale = useLocale() as Locale;
  const router = useRouter();
  const pathname = usePathname();

  const handleLocaleChange = (newLocale: Locale) => {
    router.replace(pathname, { locale: newLocale });
  };

  return (
    <Menu shadow="md" width={160} position="bottom-end">
      <Menu.Target>
        <Button
          variant="subtle"
          size="sm"
          rightSection={<IconChevronDown size={14} />}
          leftSection={<Text span>{localeFlags[locale]}</Text>}
          style={{ color: "#475569" }}
        >
          {localeNames[locale]}
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        {locales.map((loc) => (
          <Menu.Item
            key={loc}
            onClick={() => handleLocaleChange(loc)}
            leftSection={<Text span>{localeFlags[loc]}</Text>}
            style={{
              fontWeight: loc === locale ? 600 : 400,
              backgroundColor: loc === locale ? "#f1f5f9" : undefined,
            }}
          >
            {localeNames[loc]}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
